export default __webpack_public_path__ + "static/media/shantistupa1.f8765853.jpg";